export const handleContextLoss = (gl) => {
  gl.getContext().canvas.addEventListener("webglcontextlost", (event) => {
    event.preventDefault()
    console.log("WebGL context lost")
  })
  gl.getContext().canvas.addEventListener("webglcontextrestored", () => {
    console.log("WebGL context restored")
  })
}
